import { ISO_4217 } from "../../iso-4217";
import { event, GtagEvent } from "./event";
import { Item } from "./item";

export interface RemoveToCart extends GtagEvent {
    currency:ISO_4217;
    value: number;
    items:Item[]
}
export const remove_from_cart = ($_:RemoveToCart) => event('remove_from_cart',$_);